import React from 'react';
import {connect} from 'react-redux';
import {ADDSCHOOLS, VIEWSCHOOLS} from '../../constants/index';
import './styles.scss';
import strings from 'utils/strings';
import moment from 'moment';
import getConexusSchools from '../../api/getConexusSchools';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faPenToSquare, faTrash} from '@fortawesome/free-solid-svg-icons';
import AddMunicipality from 'components/AddMunicipality';
import InformationPane from 'components/InformationPane';
import deleteSchool from 'api/deleteSchool';
import EditSchoolListForEngage from './EditSchoolListForEngage';

const feideFilters = [VIEWSCHOOLS, ADDSCHOOLS];

class Conexus extends React.Component {
	constructor() {
		super();

		this.state = {
			activeFilter: VIEWSCHOOLS,
			municipalities: [],
			renderPaneAlert: false,
			paneMessage: 'Er du sikker på at du vil slette denne skolen?',
			isEditModelOpen: false,
		};
		this.fetchSchools = this.fetchSchools.bind(this);
		this.onEditItemClick = this.onEditItemClick.bind(this);
		this.onListItemDelete = this.onListItemDelete.bind(this);
	}
	componentDidMount() {
		this.fetchSchools();
	}

	fetchSchools() {
		this.setState({
			isEditModelOpen: false,
		});
		return getConexusSchools().then((municipalities) => {
			this.setState({
				municipalities,
			});
		});
	}
	onEditModelConfirm = () => {
		this.setState({
			isEditModelOpen: false,
		});
	};

	onEditModelCancel = (a) => {
		this.setState({
			isEditModelOpen: false,
		});
	};
	onEditItemClick = (id, municipalities) => {
		const municipality = municipalities.filter((item) => item.id === id);
		this.setState({
			isEditModelOpen: true,
			selectedMunicipality: municipality[0],
		});
	};
	onListItemDelete = (id) => {
		deleteSchool(id).then((res) => {
			if (!res) {
				this.setState({
					showAlert: true,
					error: true,
					success: false,
					message: 'Ops! something went wrong.',
				});
				setTimeout(() => {
					this.setState({
						showAlert: false,
					});
				}, 3000);
			} else {
				this.setState({
					showAlert: true,
					error: false,
					success: true,
					message: 'Skole ble slettet!',
				});
				this.fetchSchools();

				setTimeout(() => {
					this.setState({
						showAlert: false,
					});
				}, 3000);
			}
		});
	};

	render() {
		const {
			municipalities,
			activeFilter,
			selectedMunicipality,
			renderPaneAlert,
			isEditModelOpen,
		} = this.state;

		return (
			<div className="lit-all-tests">
				<form
					onSubmit={(event) => {
						event.preventDefault();
						this.handleSubmitTestKey();
					}}
				>
					<div className="lit-filters-row">
						<div className="lit-dropdown_filter">
							<select
								className="lit-input__field"
								defaultValue={VIEWSCHOOLS}
								onChange={(e) => {
									this.setState({
										activeFilter: feideFilters.filter(
											(filter) =>
												filter.id === e.target.value
										)[0],
									});
								}}
							>
								{feideFilters.map((userStageFilter) => (
									<option
										key={userStageFilter.id}
										value={userStageFilter.id}
									>
										{userStageFilter.label ||
											userStageFilter.text}
									</option>
								))}
							</select>
						</div>
					</div>
				</form>
				{activeFilter === VIEWSCHOOLS && (
					<div>
						{Boolean(municipalities.length < 1) && (
							<p>{strings.noSchoolsFound}</p>
						)}
						{Boolean(municipalities.length) && (
							<div className="main">
								<table className="list">
									<thead>
										<tr>
											<th>{strings.createdAt}</th>
											<th>{strings.schoolName}</th>
											<th>
												{strings.municipalityNumber}
											</th>

											<th>{strings.actions}</th>
										</tr>
									</thead>
									<tbody>
										{municipalities.map((item) => {
											console.log(
												'These are the munipalities ',
												municipalities
											);
											const {
												id,
												school,
												uuid,
												createdAt,
											} = item;

											return (
												<tr
													className="lit-list__item"
													key={id}
												>
													<td>
														{moment(
															createdAt
														).format('LLL')}
													</td>

													<td>{school}</td>
													<td>{uuid}</td>
													<td>
														<div className="action-buttons">
															<button
																className="edit-button"
																title="Edit Municipality"
																onClick={() => {
																	this.onEditItemClick(
																		id,
																		municipalities
																	);
																}}
															>
																<FontAwesomeIcon
																	size="lg"
																	className="lit-mytests-header-mytest-icon-btn-icon"
																	icon={
																		faPenToSquare
																	}
																/>
															</button>
															<button
																className="delete-button"
																title="Delete Municipality"
																onClick={() => {
																	this.setState(
																		{
																			renderPaneAlert: true,
																			selectedMunicipality: id,
																		}
																	);
																}}
															>
																<FontAwesomeIcon
																	size="lg"
																	className="lit-mytests-header-mytest-icon-btn-icon"
																	icon={
																		faTrash
																	}
																/>
															</button>
														</div>
													</td>
												</tr>
											);
										})}
									</tbody>
								</table>
							</div>
						)}
					</div>
				)}
				{activeFilter === ADDSCHOOLS && (
					<AddMunicipality
						refreshMunicipalities={this.fetchSchools}
						forFeide2={false}
					/>
				)}
				{renderPaneAlert && (
					<InformationPane
						paneMessage={this.state.paneMessage}
						onApproval={() => {
							this.setState({
								renderPaneAlert: false,
							});
							this.onListItemDelete(selectedMunicipality);
						}}
						onCloseWindow={() => {
							this.setState({
								renderPaneAlert: false,
							});
						}}
						onDisproval={() => {
							this.setState({
								renderPaneAlert: false,
							});
						}}
						category={'confirmation'}
					/>
				)}
				{isEditModelOpen && (
					<EditSchoolListForEngage
						onConfirm={this.onEditModelConfirm}
						onCancel={this.onEditModelCancel}
						selectedMunicipality={selectedMunicipality}
						refreshMunicipalities={this.fetchSchools}
					/>
				)}
			</div>
		);
	}
}

const mapStateToProps = () => {
	return {};
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Conexus);
